import { cn } from "@/lib/utils";
import { grouped } from "@repo/shared/gallery";

import { ItemScoreDiamond } from "./ItemScoreDiamond";

interface ItemScoreProps {
  score: number;
  size: "small" | "medium" | "large";
  /** The bordered chip under gallery solution cards. */
  pill?: boolean;
  /** Suffixes the score with "?": a guessed score. */
  estimated?: boolean;
  className?: string;
}

const DIAMOND_SIZE: Record<ItemScoreProps["size"], number> = {
  small: 12,
  medium: 14,
  large: 18,
};

const LABEL_SIZE: Record<ItemScoreProps["size"], string> = {
  small: "text-sm",
  medium: "text-base",
  large: "text-h3",
};

/** An item score, always in full ("2,103,450") the way EA prints gallery scores. */
export const ItemScore = ({
  score,
  size,
  pill,
  estimated,
  className,
}: ItemScoreProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-x-1 whitespace-nowrap tabular-nums",
      LABEL_SIZE[size],
      pill &&
        "min-h-6 rounded-lg border border-neutral-700 bg-neutral-900 px-1.5",
      className,
    )}
  >
    <ItemScoreDiamond size={DIAMOND_SIZE[size]} />
    <span className="font-oswald">
      {estimated ? `${grouped.format(score)}?` : grouped.format(score)}
    </span>
  </span>
);
